// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jq-danger-bg{
	background-color: #f775756e !important;
    width: 100% !important;
    padding: 10px !important;
}

.jq-danger-text{
	color: #f775756e !important;
	font-weight: bold !important;
    padding: 10px !important;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
